export const PermitTypeFormatter = {
  format: (type: string) => type.replace(/\s*,\s*/g, ', '),
};
